// LandingKids — the kids edition landing page. Mirrors Landing.jsx but spins
// up the parents-to-be + baby-shower-gift narrative around Ella's demo. Reuses
// LeaStory, HowItWorks, Pricing, Mission, Waitlist, Footer for consistency.
import { SiteNav } from "../components/SiteNav";
import { HeroKids } from "../components/sections/HeroKids";
import { ProblemKids } from "../components/sections/ProblemKids";
import { LeaStory } from "../components/sections/LeaStory";
import { WhyReminissing } from "../components/sections/WhyReminissing";
import { MeetEllaIntro } from "../components/sections/MeetEllaIntro";
import { HowItWorks } from "../components/sections/HowItWorks";
import { ProductRevealKids } from "../components/sections/ProductRevealKids";
import { PackagingShowcase } from "../components/sections/PackagingShowcase";
import { Pricing } from "../components/sections/Pricing";
import { FlexibilityOptions } from "../components/sections/FlexibilityOptions";
import { Mission } from "../components/sections/Mission";
import { Waitlist } from "../components/sections/Waitlist";
import { Footer } from "../components/sections/Footer";
import { useLenisScroll } from "../lib/useLenisScroll";

export default function LandingKids() {
    useLenisScroll();
    return (
        <div className="bg-[#FDFBF7] text-[#2D2B2A]" data-testid="landing-kids-page">
            <SiteNav />
            <main>
                <HeroKids />
                <ProblemKids />
                <LeaStory />
                <WhyReminissing />
                <MeetEllaIntro />
                <HowItWorks />
                <ProductRevealKids />
                <PackagingShowcase />
                <FlexibilityOptions />
                <Pricing />
                <Mission />
                <Waitlist />
            </main>
            <Footer />
        </div>
    );
}
